import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/module/page', data, {
    trim: true
  })
}

// 查询根模块
export function fetchRootList () {
  return request.get('/module/root/all')
}

// 创建
export function create (data) {
  return request.post('/module/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/module/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/module/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/module/delete/batch', {
    params: {
      ids
    }
  })
}
